module.exports = __webpack_public_path__ + "static/img/101866.af9d426a.png";